var _a;
export var REQUEST_TIMEOUT = 20000;
export var ZIPCODE_LENGTH = 5;
export var MAX_ALTERNATE_PHONES = 3;
export var sessionStorageKeys = {
    recentlyViewedItems: 'rvData',
    recentlyViewedDatestamp: 'RVDateStamp',
};
export var EXTERNAL_HOST_PATH = typeof window !== 'undefined' && typeof (window === null || window === void 0 ? void 0 : window.THD_GLOBAL) !== 'undefined'
    ? (_a = window === null || window === void 0 ? void 0 : window.THD_GLOBAL) === null || _a === void 0 ? void 0 : _a.nonSecureHostName
    : '';
export var SIGN_IN_HOST_PATH = "".concat(EXTERNAL_HOST_PATH, "/auth/view/signin");
export var ACCOUNT_BREADCRUMBS_BASE = [
    { url: '/', label: 'Home' },
    { url: '/myaccount/dashboard', label: 'Account' },
];
export var B2B_BREADCRUMBS = {
    home: [
        {
            label: 'customer-loyalty',
        },
    ],
    programDetails: [
        {
            label: 'Program Details',
        },
    ],
    personalizedOffers: [
        {
            path: '/myaccount/dashboard',
            label: '...',
        },
        {
            path: '/myaccount/proxtraprogramdetails',
            label: 'Program Details',
        },
        {
            label: 'Personalized Offers',
        },
    ],
    pricingBenefits: [
        {
            label: 'Pricing Benefits',
            url: '/myaccount/proXtraPricing',
        },
    ],
    proXtraPerks: [
        {
            label: 'Pro Xtra Perks',
            url: '/myaccount/proXtraPerks',
        },
    ],
    rewardsHub: [
        {
            label: 'Rewards Hub',
            url: '/myaccount/proXtraRewards',
        },
    ],
};
export var B2B_ANALYTICS = {
    pricingBenefits: {
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>pricing benefits',
            subCategory2: 'account>pricing benefits',
        },
        pageInfo: {
            pageName: 'account>pricing benefits',
            pageType: 'maml:pricing',
        },
        error: [],
    },
    proXtraPerks: {
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>perks',
            subCategory2: 'account>perks',
        },
        pageInfo: {
            pageName: 'account>perks',
            pageType: 'maml:loyalty',
        },
        error: [],
    },
    rewardsHub: {
    // category: {
    //   primaryCategory: 'account',
    //   subCategory1: 'account>pro xtra rewards',
    //   subCategory2: 'account>pro xtra rewards',
    // },
    // pageInfo: {
    //   pageName: 'account>pro xtra rewards',
    //   pageType: 'maml:loyalty',
    // },
    // error: [],
    },
};
